export default __webpack_public_path__ + "821e4a8cb65ce70d090ca87952822c73.png";